export const API_ENDPOINTS = {
  PRODUCTS: '/products',
  PRODUCTS_POPULAR: '/popular-products',
  PRODUCTS_REVIEWS: '/reviews',
  PRODUCTS_REVIEWS_ABUSE_REPORT: '/abusive_reports',
  PRODUCTS_QUESTIONS: '/questions',
  FEEDBACK: '/feedbacks',
  CATEGORIES: '/categories',
  TYPES: '/types',
  TAGS: '/tags',
  SHOPS: '/shops',
  AUTHORS: '/authors',
  AUTHORS_TOP: '/top-authors',
  MANUFACTURERS: '/manufacturers',
  MANUFACTURERS_TOP: '/top-manufacturers',
  COUPONS: '/coupons',
  COUPONS_VERIFY: '/coupons/verify',
  ORDERS: '/orders',
  ORDERS_REFUNDS: '/refunds',
  ORDERS_PAYMENT: '/orders/payment',
  ORDERS_CHECKOUT_VERIFY: '/orders/checkout/verify',
  ORDERS_DOWNLOADS: '/downloads',
  GENERATE_DOWNLOADABLE_PRODUCT_LINK: '/downloads/digital_file',
  USERS: '/users',
  USERS_ADDRESS: '/address',
  USERS_ME: '/me',
  USERS_LOGIN: '/token',
  USERS_REGISTER: '/register',
  USERS_FORGOT_PASSWORD: '/forget-password',
  USERS_VERIFY_FORGOT_PASSWORD_TOKEN: '/verify-forget-password-token',
  USERS_RESET_PASSWORD: '/reset-password',
  USERS_CHANGE_PASSWORD: '/change-password',
  USERS_CONFIRM_PASSWORD: '/confirm-password',
  USERS_LOGOUT: '/logout',
  USERS_DELETE: '/users',
  USERS_SUBSCRIBE_TO_NEWSLETTER: '/subscribe-to-newsletter',
  USERS_CONTACT_US: '/contact-us',
  USERS_AFFILIATE: '/affiliate/apply',
  USERS_WISHLIST: '/my-wishlists',
  WISHLIST: '/wishlists',
  USERS_WISHLIST_TOGGLE: '/wishlists/toggle',
  SOCIAL_LOGIN: '/social-login-token',
  SEND_OTP_CODE: '/send-otp-code',
  VERIFY_OTP_CODE: '/verify-otp-code',
  OTP_LOGIN: '/otp-login',
  UPDATE_CONTACT: '/update-contact',
  SETTINGS: '/settings',
  UPLOADS: '/attachments/api',
  MY_QUESTIONS: '/my-questions',
  MY_REPORTS: '/my-reports',
  CARDS: '/cards',
  SET_DEFAULT_CARD: '/set-default-card',
  SAVE_PAYMENT_METHOD: '/save-payment-method',
  PAYMENT_INTENT: '/payment-intent',
  CYBERSOURCE_CAPTURE_CONTEXT: '/payments/cybersource/capture-context',
  CYBERSOURCE_SETUP: '/payments/cybersource/setup',
  CYBERSOURCE_AUTHENTICATE: '/payments/cybersource/authenticate',
  CYBERSOURCE_SAVED: '/payments/cybersource/saved',
  CYBERSOURCE_CARDS: '/payments/cybersource/cards',
  BEST_SELLING_PRODUCTS: '/best-selling-products',
  SEND_VERIFICATION_EMAIL: '/email/verification-notification',
  USERS_UPDATE_EMAIL: '/update-email',
  STORE_NOTICES: 'store-notices',
  FAQS: '/faqs',
  NEAR_SHOPS: '/near-by-shop',
  REFUNDS_REASONS: 'refund-reasons',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  FLASH_SALE: 'flash-sale',
  PRODUCT_FLASH_SALE_INFO: 'product-flash-sale-info',
  REFUND_POLICIES: 'refund-policies',
  PRODUCTS_BY_FLASH_SALE: 'products-by-flash-sale',
  NOTIFY_LOGS: 'notify-logs',
  STORE_NOTICES_IS_READ: 'store-notices/read',
  READ_ALL_NOTIFY_LOG: 'notify-log-read-all',
  READ_NOTIFY_LOG: 'notify-log-seen',
  SHOP_MAINTENANCE_EVENT: 'shop-maintenance-event',
  NAVIGATION_CATEGORY_MENU: 'navigation-menu',
  HOMEPAGE_SECTION: 'homepage/sections',
  BANNERS: 'banners',
};
